module.exports = __webpack_public_path__ + "static/raks-7e274b8aade5243735583fec552dba9e.png";